import axiosClient from "./axiosClient";

export const getOptInConfig = (companyId) => {
    return axiosClient.get(`/companies/${companyId}/review-leaderboard-optin`);
}

export const setOptInConfig = (storeId, data) => {
    return axiosClient.put(`/companies/stores/${storeId}/review-leaderboard-optin`, data);
}

export const setOptInConfigForAllStores = (companyId, data) => {
    return axiosClient.put(`/companies/${companyId}/review-leaderboard-optin`, data);
}